<template>
    <div>
        <div class="grid
                    grid-cols-12
                    gap-4">
            <div class="col-span-12 desktop:col-span-10">
                <div v-if="isRecommended"
                     class="desktop:hidden
                            w-full
                            mb-2
                            px-2
                            py-1
                            text-xs
                            text-navy-dark
                            text-center
                            font-book
                            uppercase
                            bg-salmon">
                    Recommended
                </div>
                <div class="font-bold
                            text-lg desktop:text-xl
                            text-center desktop:text-left
                            leading-snug"
                     :class="subtitle ? 'mb-0' : 'mb-4'">
                    {{ title }}
                    <span v-if="isRecommended"
                          class="hidden desktop:inline-block
                                 px-2
                                 py-1
                                 text-xs
                                 text-navy-dark
                                 font-book
                                 uppercase
                                 bg-salmon
                                 relative
                                 -top-1">
                        Recommended
                    </span>
                </div>
                <div v-if="subtitle"
                     class="text-sm
                            font-book
                            text-center desktop:text-left
                            leading-snug
                            mb-4">
                    {{ subtitle }}
                </div>
                <div class="text-sm desktop:text-sm
                            leading-normal
                            desktop:pr-6">
                    <slot />
                </div>
            </div>
            <div class="col-span-12 desktop:col-span-2
                        relative
                        flex
                        flex-row desktop:flex-col
                        items-end
                        mt-4 desktop:mt-0"
                 :class="price >= 0 ? 'justify-between' : 'justify-end'">
                <PricePerMonth v-if="price >= 0"
                               :price="price" />
                <slot v-if="$slots.trigger" name="trigger"/>

                <button
                    v-else
                    @click.prevent="$emit('select')"
                    :disabled="isSelected || isFiber"
                    class="buyflow-button flex items-center"
                >
                    <template v-if="isSelected || isFiber">
                        <IconCheck class="mr-1" />
                        {{ buttonTextSelected }}
                    </template>
                    <template v-else>
                         {{ buttonText }}
                    </template>
                </button>
            </div>
        </div>
        <slot v-if="isSelected || isFiber"
              name="extra" />
    </div>
</template>

<script>
    import IconCheck from "@/atoms/icons/IconCheck"
    import PricePerMonth from '@/atoms/PricePerMonth'

    export default {
        name: 'ModemOption',
        components: {
            IconCheck,
            PricePerMonth,
        },
        props: {
            title: {
                type: String,
                required: true,
                default: null,
            },
            subtitle: {
                type: String,
                default: null,
            },
            isRecommended: {
                type: Boolean,
                default: false,
            },
            price: {
                type: [Number, undefined],
                default: -1,
            },
            buttonText: {
                type: String,
                default: 'Select',
            },
            buttonTextSelected: {
                type: String,
                default: 'Selected',
            },
            isSelected: {
                type: Boolean,
                default: false,
            },
            isFiber: {
                type: Boolean,
                default: false,
            }
        },
    }
</script>
